import React from 'react';

import { Grid, Typography, makeStyles } from '@material-ui/core';
import i18n from 'i18n';
import {
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { RolesEnum } from 'modules/authenticate/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import { modalOpen } from 'modules/modal/actions';
import {
  getDashboardSessionsGraphRequest,
  setPeriodFilter,
} from 'modules/environments/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { isClientOperator } from 'utils/role';
import { useParams } from 'react-router';
import EnvironmentGraphCard from '../EnvironmentGraphCard';
import styles, { overrideModalGraph } from './styles';
import SessionHistoryGraph from './SessionHistoryGraph';
import SessionHistoryModal from './SessionHistoryModal';

interface SessionsHistoryGraphCardPerformanceProps {
  dateFilter?: DateFilterFields;
  role?: RolesEnum;
  periodFilter: PeriodCountAccess;
  getDashboardSessionsGraphRequest: ({ id, query }) => void;
  modalOpen: (props: ModalFields) => void;
  setPeriodFilter: (prop: string) => void;
}

const SessionsHistoryGraphCardPerformance = ({
  dateFilter,
  role,
  periodFilter,
  modalOpen,
  getDashboardSessionsGraphRequest,
}: SessionsHistoryGraphCardPerformanceProps) => {
  const classes = makeStyles(styles())();
  const { id } = useParams<{
    id: string;
  }>();

  const getDashboardSessionsGraph = React.useCallback(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period: periodFilter };

    getDashboardSessionsGraphRequest({ id, query });
  }, [getDashboardSessionsGraphRequest, id, periodFilter, dateFilter]);

  React.useEffect(() => {
    getDashboardSessionsGraph();
  }, [getDashboardSessionsGraph]);

  const handleOpenGraphModal = () => {
    modalOpen({
      overrideClasses: overrideModalGraph,
      maxWidth: 'xl',
      title: i18n.t('PERFORMANCE_PAGE.SESSIONS_AND_VACANCIES_DETAILS_KEY'),
      content: <SessionHistoryModal />,
      onClose: () => getDashboardSessionsGraph(),
      genericFooter: {},
    });
  };

  return (
    <Grid item className={classes.sessionHistoryContainer}>
      <Grid container className={classes.cardHeader}>
        <Grid item xs={6} justify="flex-start">
          <Typography className={classes.sessionsVacancies}>
            {i18n.t('PERFORMANCE_PAGE.SESSIONS_AND_VACANCIES_KEY')}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.header}>
          <Typography className={classes.graphLegendItem}>
            <FiberManualRecordIcon className={classes.graphSessions} />
            {i18n.t('ENVIRONMENT_DASHBOARD.SESSIONS_MAX_KEY')}
          </Typography>
          {!isClientOperator(role) && (
            <Typography className={classes.graphLegendItem}>
              <FiberManualRecordIcon className={classes.graphVacancies} />
              {i18n.t('ENVIRONMENT_DASHBOARD.VACANCIES_MAX_KEY')}
            </Typography>
          )}
        </Grid>
      </Grid>
      <EnvironmentGraphCard>
        <Grid item xs={12} onClick={() => handleOpenGraphModal()}>
          <SessionHistoryGraph />
        </Grid>
      </EnvironmentGraphCard>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter },
  authenticate: { data },
}: ApplicationState) => ({
  role: data?.role,
  periodFilter,
});

export default connect(mapStateToProps, {
  getDashboardSessionsGraphRequest,
  modalOpen,
  setPeriodFilter,
})(SessionsHistoryGraphCardPerformance);
